var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"version2-bottom-middle"},[_c('div',{staticClass:"version2-bottom-middle-block"},[_c('CollageTotal'),_c('Inventor')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }